import moment from 'moment';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import Cell from './Cell';
import { weekFirstDay } from '../../helpers/dates';
import CalendarHeader from './CalendarHeader';
import './Calendar.scss';
import cn from "classnames";

const now = moment();
const isMobile = window.innerWidth <= 480;

const createWeekRow = (fn) => Array.from({ length: 7 }, fn);

const Calendar = ({ week, events, isLoading, onClickCell }) => {
  const firstDayWeek = weekFirstDay(week);
  const defaultDate = moment().week() === week ? now : firstDayWeek;
  const [activeTab, setActiveTab] = useState(defaultDate);

  const changeTab = (date) => {
    if (isMobile) {
      setActiveTab(date);
    }
  }

  useEffect(() => {
    changeTab(defaultDate);
  }, [week]);  /* eslint-disable-line react-hooks/exhaustive-deps */

  const headerDays = createWeekRow((val, index) => moment(firstDayWeek).add(index, 'd'));

  const getCols = () => Object.keys(events).map((date, colIndex) => {
    const eventsBlock = events[date].map((event, index) => {
      if (event) {
        return <Cell key={`${date}-${index}`} event={event} isLoading={isLoading} onClick={onClickCell} />;
      }
      return null;
    });

    const isToday = moment().isSame(date, 'day');
    const columnClasses = cn('xti-calendar__column', {
      'xti-calendar__column--today': isToday,
      'xti-calendar__column--active': moment(activeTab).isSame(date, 'day'),
    });
    return <div className={columnClasses} key={`${date}-col`}>
        {eventsBlock}
    </div>;
  });

  return (
    <div className="xti-calendar">
      <CalendarHeader days={headerDays} activeDay={activeTab} onCellClick={changeTab}/>
      <Scrollbars style={{ height: isMobile ? 'calc(100vh - 132px)' : 322 }}>
        <div className="xti-calendar__content">
          {getCols()}
        </div>
      </Scrollbars>
    </div>
  );
};

Calendar.defaultProps = {
  events: {},
};

Calendar.propTypes = {
  week: PropTypes.number.isRequired,
  events: PropTypes.objectOf(PropTypes.array),
  onClickCell: PropTypes.func.isRequired,
};

export default Calendar;
